// src/api_scripts/createAuxCode.js
import { createApiClient } from "../apiClient";

const createAuxCode = async (
  auxCodeData,
  orgId,
  accessToken,
  setProgress
) => {
  console.log("auxCodeData", auxCodeData);
  const { name, type, idleCodeWorkTypeId, wraupupWorktTypeId } = auxCodeData;

  // Validate the type
  if (type !== "Idle Code" && type !== "Wrap Up Code") {
    const errorMessage = `Invalid Aux Code Type: "${type}". Must be 'Idle Code' or 'Wrap Up Code'.`;
    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw new Error(errorMessage);
  }

  // Determine the classificationId based on the provided type
  let classificationId;
  let classificationName;
  if (type === "Idle Code") {
    classificationId = idleCodeWorkTypeId;
    classificationName = "IDLE_CODE";
  } else if (type === "Wrap Up Code") {
    classificationId = wraupupWorktTypeId;
    classificationName = "WRAP_UP_CODE";
  } else {
    // This case should ideally be caught by the validation above, but as a fallback
    const errorMessage = `Could not determine classification ID for type: ${type}`;
    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw new Error(errorMessage);
  }

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Aux Code: "${name}" with type "${type}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);

  // The URI should be relative to the base URL defined in createApiClient
  const relativeUri = `/organization/${orgId}/auxiliary-code`;

  try {
    const apiClient = createApiClient(accessToken);

    const requestBody = {
      name: name,
      active: true,
      workTypeId: classificationId,
      workTypeCode: classificationName,
      defaultCode: false
    };

    const response = await apiClient.post(relativeUri, requestBody);

    // The API typically returns the created resource directly or within a 'data' property.
    const newAuxCode = response.data;

    console.log("Create Aux Code API Response Data:", newAuxCode);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created Aux Code "${name}" (ID: ${newAuxCode.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newAuxCode; // Return the created aux code object

  } catch (error) {
    console.error(`Error creating Aux Code "${name}":`, error);

    let errorMessage = `Error creating Aux Code "${name}": ${error.message || String(error)}`;

    // Check for specific API error response structure to add more detail
    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error; // Re-throw the error for the calling function to handle
  }
};

export default createAuxCode;
